import { encrypt } from '../encrypt'
import { navigationMethods } from './navigationMethods'

export default {
  navigation: navigationMethods,
  security: {
    encryptData: encrypt,
  },
  // TO DEPRECATE: https://toqio.atlassian.net/wiki/spaces/TAAP/pages/4195581963/Renaming+methods+for+Workflows
  customMethods: {
    encryptData: encrypt
  },
}